import React, { useState } from 'react';
import styled from 'styled-components';
import { UserActivity } from './details/UserActivity';
import { UserInformation } from './details/UserInformation';
import { UserWalletTransactions } from './details/UserWalletTransactions';
import { useLocation } from 'react-router-dom';
import UserTransactionCharges from './charges/UserTransactionCharges';

export const UserTabs = ({ user }) => {
  const [activeTab, setActiveTab] = useState(0);
  // const location = useLocation();
  // const user = location.state?.selectedUser;

  const tabs = [
    {
      label: 'User Information',
      content: <UserInformation />
    },
    {
      label: 'User Activity',
      content: <UserActivity />
    },
    {
      label: 'User Wallet Transactions',
      // content: <UserWalletTransactions user={user} />
      content: <UserWalletTransactions />
    },
    {
      label: 'User Charges',
      content: <UserTransactionCharges user={user} />
    }
  ];
  
  // console.log(user);

  return (
    <Tab>
      <TabView>
        {tabs.map((item, index) => (
          <button
            key={index}
            className={`tab ${activeTab === index ? 'active' : ''}`}
            onClick={() => setActiveTab(index)}>
            {item.label}
          </button>
        ))}
      </TabView>
      <TabContent>{tabs[activeTab].content}</TabContent>
    </Tab>
  );
};

const Tab = styled.div`
  width: 100%;
  height: 100%;
`;

const TabView = styled.div`
  height: 50px;
  display: flex;
  z-index: 10;
  margin-left: -30px;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme }) => theme.colors?.white};
  border-bottom: 1px solid ${(props) => props.theme?.colors?.line};

  button {
    padding: 16px 32px;
    border: none;
    background-color: transparent;
    font-size: 1rem;
    font-weight: 500;
    transition: all 0.2s ease-in-out;
    border-bottom: 2px solid transparent;

    &:hover {
      color: ${(props) => props.theme?.colors?.secondary};
    }
  }

  .active {
    color: ${(props) => props.theme?.colors?.secondary};
    border-bottom: 2px solid ${(props) => props.theme?.colors?.secondary};
  }
`;

const TabContent = styled.div`
  width: 100%;
  height: 100%;
`;